import { ApiErrorModel } from '../types/ApiErrorModel';

export const isFriendlyForbiddenError = (error: ApiErrorModel): boolean =>
  error.status === 403 && !!error.detail;
